module.exports = __webpack_public_path__ + "static/media/diamond-icon.391a6b2c.png";